module.exports = __webpack_public_path__ + "img/ico_menual10_on.74586539.svg";